// PALMENZA small UI layer: scroll reveals and a gold sparkle when something is added to the cart.
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

function initReveals() {
  const items = document.querySelectorAll('[data-pz-reveal]:not(.is-in)');
  if (!items.length) return;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );
  items.forEach((el) => io.observe(el));
}

function sparkle(x, y) {
  if (reduceMotion) return;
  for (let i = 0; i < 12; i++) {
    const s = document.createElement('span');
    const angle = (Math.PI * 2 * i) / 12 + Math.random() * 0.4;
    const dist = 28 + Math.random() * 30;
    s.className = 'pz-sparkle';
    s.style.left = `${x - 4}px`;
    s.style.top = `${y - 4}px`;
    s.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
    s.style.setProperty('--dy', `${Math.sin(angle) * dist}px`);
    document.body.append(s);
    s.addEventListener('animationend', () => s.remove(), { once: true });
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('add-to-cart-component button, button[name="add"], .add-to-cart-button');
  if (!button || button.disabled) return;
  const r = button.getBoundingClientRect();
  sparkle(r.left + r.width / 2, r.top + r.height / 2);
});

document.documentElement.classList.add('pz-js');
initReveals();
// Theme editor re-renders sections; re-observe new content.
document.addEventListener('shopify:section:load', initReveals);
